export default "__VITE_ASSET__Di2v4sfj__"